import { getCountryNameByCode, } from '@/utils/countries'

export const addPath = (
  {
    country,
    addressLines = [],
    addressNumber,
    addressNumberWithinBuilding,
    mailRouting,
    postalCode,
    city,
    region,
  },
  rootPath
) => {
  const create = (value, path) => createRow(value, rootPath, path)
  return {
    addressLines:
      [ ...addressLines, ...new Array(4).fill(null), ]
        .slice(0, 4)
        .map((line, i) => i === 0 ? create(line, 'FirstAddressLine') : create(line, `addressLines[${i}]`)),
    postalCode: create(postalCode, 'postalCode'),
    addressNumber: create(addressNumber, 'addressNumber'),
    addressNumberWithinBuilding: create(addressNumberWithinBuilding, 'addressNumberWithinBuilding'),
    mailRouting: create(mailRouting, 'mailRouting'),
    city: create(city, 'city'),
    region: create(region, 'region'),
    country: create(country, 'country'),
  }
}

export const createRow = (value, root, path) => ({
  value,
  jsonPath: `$.${root}.${path}`,
})

export const parser = {
  'country': (val) => ({
    code: val,
    name: getCountryNameByCode(val),
  }),
  'region': (val) => ({ code: val || '', }),
}

export const createNewRow = (oldAddress, newAddress, property, index = null) => {
  const getValue = (address) => {
    return index !== null
      ? address[property][index]
        ? address[property][index].value
        : null
      : address[property].value
  }
  const getJsonPath = () => {
    const oldA = oldAddress[property]
    const newA = newAddress[property]
    const address = index !== null ? oldA.length > newA.length ? oldA[index] : newA[index] : oldA
    return address.jsonPath
  }

  const oldValue = parser[property] ? parser[property](getValue(oldAddress)) : getValue(oldAddress)
  const newValue = getValue(newAddress)
  const jsonPath = getJsonPath()
  const cond = parser[property] ? oldValue.code === newValue.code : newValue === oldValue

  return {
    value: oldValue,
    newValue: cond ? null : newValue,
    jsonPath,
  }
}

export const createField = ({ value, newValue, jsonPath, }, comment = '') => {
  return newValue ? {
    original_value: value,
    proposed_value: newValue,
    comment,
    field: jsonPath,
  } : null
}

export const compare = (oldAddress, newAddress) => {
  const create = (prop, index = null) => createNewRow(oldAddress, newAddress, prop, index)
  const oldLines = oldAddress.addressLines
  const newLines = newAddress.addressLines
  const addressLines = oldLines.length > newLines.length ? oldLines : newLines
  return {
    addressLines: addressLines.map((line, i) => create('addressLines', i)),
    postalCode: create('postalCode'),
    city: create('city'),
    region: create('region'),
    country: create('country'),
    addressNumber: create('addressNumber'),
    addressNumberWithinBuilding: create('addressNumberWithinBuilding'),
    mailRouting: create('mailRouting'),
  }
}

export const getFields = ({
  addressLines, postalCode, city,
  region, country, addressNumber,
  addressNumberWithinBuilding, mailRouting,
}, comment) => {
  const create = (filed) => createField(filed, comment)
  return [
    ...addressLines.map((line) => create(line)),
    create(postalCode),
    create(city),
    create(region),
    create(country),
    create(addressNumber),
    create(addressNumberWithinBuilding),
    create(mailRouting),
  ].filter((f) => f !== null)
}



// WEBPACK FOOTER //
// ./src/utils/address.js